// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-d36f8c40]{text-decoration:none}.back-link[data-v-d36f8c40]{margin-left:90px}", ""]);
// Exports
module.exports = exports;
